import type { UserOwnInfo } from "@ka-astro/auth";
import type { UserProfile } from "@ka-astro/header/components/HeaderBottom/userProfile.d.ts";
import { atom } from "nanostores";

/**
 * User Store
 *
 * This store is used to share the user data between the micro-frontends and also
 * check if the user is logged in.
 *
 * @see https://github.com/nanostores/nanostores
 */

export const userStore = atom<UserOwnInfo | null>(null);
export const isUserLoggedInStore = atom<boolean>(false);
export const userProfileStore = atom<UserProfile | null>(null);
